export const timeRanges = [
    { label: 'Hier', value: 1 },
    { label: '7 jours', value: 7 },
    { label: '30 jours', value: 30 },
    { label: '365 jours', value: 365 },
    { label: 'Sélectionner des dates', value: 0 },
];
